export default (sortDirection: string, sortField: string) => (b: object, a: object) => {
    if (sortDirection === "asc") { // @ts-ignore
        return (`${b[sortField]}`).localeCompare(`${a[sortField]}`);
    }
    // @ts-ignore
    return (`${a[sortField]}`).localeCompare(`${b[sortField]}`);
}
